import { unstable_IdlePriority as idlePriority, unstable_scheduleCallback as scheduleCallback } from 'scheduler';
import { startLighthouseObserver } from '../additional-payload';
import { setUFOConfig } from '../config';
import { setupHiddenTimingCapture } from '../hidden-timing';
import { postInteractionLog, sinkInteractionHandler, sinkPostInteractionLogHandler } from '../interaction-metrics';
import { getVCObserver } from '../vc';
let initialized = false;
function sinkInteraction(instance, payloadPackage) {
  sinkInteractionHandler((interactionId, interaction) => {
    scheduleCallback(idlePriority, () => {
      const payloads = payloadPackage.createPayloads(interactionId, interaction);
      payloads === null || payloads === void 0 ? void 0 : payloads.forEach(payload => {
        instance.sendOperationalEvent(payload);
      });
    });
  });
}
function sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
  sinkPostInteractionLogHandler(logOutput => {
    scheduleCallback(idlePriority, () => {
      const payload = createPostInteractionLogPayload(logOutput);
      if (payload) {
        instance.sendOperationalEvent(payload);
      }
    });
  });
}
export const init = (analyticsWebClientAsync, config) => {
  var _config$vc;
  if (initialized) {
    return;
  }
  if (window !== undefined) {
    window.__REACT_UFO_ENABLE_PERF_TRACING = Boolean(sessionStorage.getItem('additionalPerfMarks') === 'true');
  }
  setUFOConfig(config);
  if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
    const vcOptions = {
      heatmapSize: config.vc.heatmapSize,
      oldDomUpdates: config.vc.oldDomUpdates,
      devToolsEnabled: config.vc.devToolsEnabled,
      selectorConfig: config.vc.selectorConfig
    };
    getVCObserver(vcOptions).start({
      startTime: 0
    });
    postInteractionLog.initializeVCObserver(vcOptions);
    postInteractionLog.startVCObserver({
      startTime: 0
    });
  }
  setupHiddenTimingCapture();
  startLighthouseObserver();
  initialized = true;
  Promise.all([analyticsWebClientAsync,
  // eslint-disable-next-line import/dynamic-import-chunkname
  import( /* webpackChunkName: "create-payloads" */'../create-payload'),
  // eslint-disable-next-line import/dynamic-import-chunkname
  import( /* webpackChunkName: "create-post-intreaction-log-payload" */'../create-post-interaction-log-payload')]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage]) => {
    if (awc.getAnalyticsWebClientPromise) {
      awc.getAnalyticsWebClientPromise().then(client => {
        var _config$postInteracti;
        const instance = client.getInstance();
        sinkInteraction(instance, payloadPackage);
        if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) {
          sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
        }
      });
    } else if (awc.sendOperationalEvent) {
      var _config$postInteracti2;
      sinkInteraction(awc, payloadPackage);
      if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) {
        sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
      }
    }
  });
};